import { render, staticRenderFns } from "./SetSizesOnDrinkStep.vue?vue&type=template&id=1df4d2b0&scoped=true&"
import script from "./SetSizesOnDrinkStep.vue?vue&type=script&lang=js&"
export * from "./SetSizesOnDrinkStep.vue?vue&type=script&lang=js&"
import style0 from "./SetSizesOnDrinkStep.vue?vue&type=style&index=0&id=1df4d2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4d2b0",
  null
  
)

export default component.exports